/**
 * Type guard for string
 * @param obj input object to check if it matches the string type
 * @returns true if input object is a string (even empty string!), false otherwise.
 */
export const isString = (obj: unknown): obj is string =>
  typeof obj === "string";

/**
 * Type guard for boolean
 * @param obj input object to check if it matches the boolean type
 * @returns true if input object is a boolean, false otherwise
 */
export const isBoolean = (obj: unknown): obj is boolean =>
  typeof obj === "boolean";

/**
 * Type guard for number
 * @param obj input object to check if it matches the number type
 * @returns true if input object is a number, false otherwise
 */
export const isNumber = (obj: unknown): obj is number =>
  typeof obj === "number" && !Number.isNaN(obj);

/**
 * Evaluates whether the provided object is an empty object (i.e. has no keys)
 * @param obj the object to check
 * @returns true if the object is an empty object, false otherwise
 */
export const isEmptyObject = (obj: unknown): boolean =>
  typeof obj === "object" && obj !== null && Object.keys(obj).length === 0;
